<fin-travel-guide [content]="content()" [showHeading]="true" />

@if (related(); as content) {
  @for (item of content; track $index) {
    @if (item.teaserTitle) {
      <fin-expand
        class="block"
        [class.mr-xlarge-t]="isNewBrand() && $first"
        [class.border-bottom]="$last"
        [key]="'cms-travel-guide-' + item.contentId"
        [id]="'cms-travel-guide-' + item.contentId + '-' + $index"
        #expand
      >
        <div class="trigger flex flex--center border-top pr-small-y">
          <div class="flex-1">
            <h3 class="mr-clear-t nordic-blue-900-text text-icon-primary">{{ item.teaserTitle }}</h3>
          </div>
          <fcom-icon
            class="flex-1 flex--nogrow rotate icon-medium"
            [class.rotate-active]="expand.isOpen$ | async"
            [name]="SvgLibraryIcon.CHEVRON_DOWN"
          />
        </div>
        <div class="content">
          <fin-travel-guide [content]="item" [showHeading]="false" />
        </div>
      </fin-expand>
    }
  }
}
